export const questions = [
	{
		id: 1,
		question: "Which plan should I choose?",
		answer:
			"You can pay with a credit card or via net banking (if you’re in United States). We will renew your subscription automatically at the end of every billing cycle.",
	},
	{
		id: 2,
		question: "Can I cancel anytime?",
		answer:
			"An accordion is used to show (and hide) HTML content. Use the w3-hide class to hide the accordion content.",
	},
	{
		id: 3,
		question: "Do I get a refund if I leave in the middle of the month?",
		answer:
			"An accordion is used to show (and hide) HTML content. Use the w3-hide class to hide the accordion content.",
	},
	{
		id: 4,
		question: "How many things will you include in your daily emails?",
		answer:
			"An accordion is used to show (and hide) HTML content. Use the w3-hide class to hide the accordion content.",
	},
	{
		id: 5,
		question: "What is custom data integration?",
		answer:
			"An accordion is used to show (and hide) HTML content. Use the w3-hide class to hide the accordion content.",
	},
	{
		id: 6,
		question: "How do you help us with improving our customer experience?",
		answer:
			"An accordion is used to show (and hide) HTML content. Use the w3-hide class to hide the accordion content.",
	},
	{
		id: 7,
		question:
			"Does Visual COGS help businesses listed on other e-commerce platforms too?",
		answer:
			"An accordion is used to show (and hide) HTML content. Use the w3-hide class to hide the accordion content.",
	},
	{
		id: 8,
		question: "Is our data safe with you?",
		answer:
			"An accordion is used to show (and hide) HTML content. Use the w3-hide class to hide the accordion content.",
	},
	{
		id: 9,
		question: "What if our competitors also use your product?",
		answer:
			"An accordion is used to show (and hide) HTML content. Use the w3-hide class to hide the accordion content.",
	},
	{
		id: 10,
		question: "How do I upgrade my plan?",
		answer:
			"An accordion is used to show (and hide) HTML content. Use the w3-hide class to hide the accordion content.",
	},
	{
		id: 11,
		question: "How does Visual COGS work?",
		answer:
			"An accordion is used to show (and hide) HTML content. Use the w3-hide class to hide the accordion content.",
	},
	{
		id: 12,
		question: "What payment method do you take?",
		answer:
			"An accordion is used to show (and hide) HTML content. Use the w3-hide class to hide the accordion content.",
	},
];
